"use strict";
exports.__esModule = true;
var react_1 = require("react");
var onCloseAction = function () {
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
};
var useOpenModal = function (_a) {
    var isOpen = _a.isOpen, setIsShowing = _a.setIsShowing, closeBtnRef = _a.closeBtnRef;
    var firstUpdate = react_1.useRef(true);
    react_1.useEffect(function () {
        var isSubscribed = true;
        if (isSubscribed) {
            if (firstUpdate.current) {
                firstUpdate.current = false;
                return;
            }
            if (isOpen) {
                setIsShowing(true);
                document.body.style.overflow = 'hidden';
                document.documentElement.style.overflow = 'hidden';
                if (closeBtnRef.current !== null) {
                    closeBtnRef.current.focus();
                }
            }
            else {
                setIsShowing(false);
                onCloseAction();
            }
        }
        return function () {
            onCloseAction();
            isSubscribed = false;
        };
    }, [isOpen]);
};
exports["default"] = useOpenModal;
